/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ArchiveWorkOrdersDto,
  ArchiveWorkOrdersResultDto,
  BatchAddWorkOrdersDto,
  BatchRemoveWorkOrdersDto,
  BatchUpdateWorkOrdersDto,
  CommitDraftDatesDto,
  CommitDraftDatesResultDto,
  CommitPullDraftDatesDto,
  CommitPullDraftDatesResultDto,
  CreateProjectPlanningDto,
  DraftDatesPreviewDto,
  ProjectPlanningControllerGetProjectPlanningParams,
  ProjectPlanningControllerListProjectsPlanningParams,
  ProjectPlanningControllerPreviewDraftDatesParams,
  ProjectPlanningControllerPreviewPullDraftDatesParams,
  ProjectPlanningDetailDto,
  ProjectPlanningListItemDto,
  ProjectWorkOrderDetailDto,
  PullDraftDatesPreviewDto,
  RedraftProjectDto,
  ReleaseRoutePreviewDto,
  UnarchiveWorkOrdersDto,
  UnarchiveWorkOrdersResultDto,
  UpdateProjectColumnConfigDto,
  UpdateProjectPlanningDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns all non-archived projects for the given partner with planning status (draft/released), distinct factory names, and work order counts. Ordered by creation date descending. Callers must be a member of the requested partner (admins bypass this check).
 * @summary List projects for a partner with planning info
 */
export type projectPlanningControllerListProjectsPlanningResponse200 = {
  data: ProjectPlanningListItemDto[]
  status: 200
}

export type projectPlanningControllerListProjectsPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerListProjectsPlanningResponse403 = {
  data: void
  status: 403
}
    
export type projectPlanningControllerListProjectsPlanningResponseSuccess = (projectPlanningControllerListProjectsPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerListProjectsPlanningResponseError = (projectPlanningControllerListProjectsPlanningResponse401 | projectPlanningControllerListProjectsPlanningResponse403) & {
  headers: Headers;
};

export type projectPlanningControllerListProjectsPlanningResponse = (projectPlanningControllerListProjectsPlanningResponseSuccess | projectPlanningControllerListProjectsPlanningResponseError)

export const getProjectPlanningControllerListProjectsPlanningUrl = (params: ProjectPlanningControllerListProjectsPlanningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/planning?${stringifiedParams}` : `/projects/planning`
}

export const projectPlanningControllerListProjectsPlanning = async (params: ProjectPlanningControllerListProjectsPlanningParams, options?: RequestInit): Promise<projectPlanningControllerListProjectsPlanningResponse> => {
  
  return customFetch<projectPlanningControllerListProjectsPlanningResponse>(getProjectPlanningControllerListProjectsPlanningUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerListProjectsPlanningQueryKey = (params?: ProjectPlanningControllerListProjectsPlanningParams,) => {
    return [
    `/projects/planning`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProjectPlanningControllerListProjectsPlanningQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerListProjectsPlanningQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>> = ({ signal }) => projectPlanningControllerListProjectsPlanning(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerListProjectsPlanningQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>>
export type ProjectPlanningControllerListProjectsPlanningQueryError = void


export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List projects for a partner with planning info
 */

export function useProjectPlanningControllerListProjectsPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List projects for a partner with planning info
 */
export const prefetchProjectPlanningControllerListProjectsPlanningQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 queryClient: QueryClient, params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerListProjectsPlanningSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerListProjectsPlanningQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>> = ({ signal }) => projectPlanningControllerListProjectsPlanning(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerListProjectsPlanningSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>>
export type ProjectPlanningControllerListProjectsPlanningSuspenseQueryError = void


export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List projects for a partner with planning info
 */

export function useProjectPlanningControllerListProjectsPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError = void>(
 params: ProjectPlanningControllerListProjectsPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerListProjectsPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerListProjectsPlanningSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new project in draft status under the given partner. Used by the new Production Planning UI. Mirrors the admin-only event-sourced `POST /projects` but is gated by PartnerAccessGuard and forces project_status = "draft" so new projects start in the planning workflow.
 * @summary Create a project (cookie-auth)
 */
export type projectPlanningControllerCreateProjectPlanningResponse201 = {
  data: ProjectPlanningListItemDto
  status: 201
}

export type projectPlanningControllerCreateProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCreateProjectPlanningResponse403 = {
  data: void
  status: 403
}
    
export type projectPlanningControllerCreateProjectPlanningResponseSuccess = (projectPlanningControllerCreateProjectPlanningResponse201) & {
  headers: Headers;
};
export type projectPlanningControllerCreateProjectPlanningResponseError = (projectPlanningControllerCreateProjectPlanningResponse401 | projectPlanningControllerCreateProjectPlanningResponse403) & {
  headers: Headers;
};

export type projectPlanningControllerCreateProjectPlanningResponse = (projectPlanningControllerCreateProjectPlanningResponseSuccess | projectPlanningControllerCreateProjectPlanningResponseError)

export const getProjectPlanningControllerCreateProjectPlanningUrl = () => {


  

  return `/projects/planning`
}

export const projectPlanningControllerCreateProjectPlanning = async (createProjectPlanningDto: CreateProjectPlanningDto, options?: RequestInit): Promise<projectPlanningControllerCreateProjectPlanningResponse> => {
  
  return customFetch<projectPlanningControllerCreateProjectPlanningResponse>(getProjectPlanningControllerCreateProjectPlanningUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProjectPlanningDto,)
  }
);}




export const getProjectPlanningControllerCreateProjectPlanningMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,{data: CreateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,{data: CreateProjectPlanningDto}, TContext> => {

const mutationKey = ['projectPlanningControllerCreateProjectPlanning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, {data: CreateProjectPlanningDto}> = (props) => {
          const {data} = props ?? {};

          return  projectPlanningControllerCreateProjectPlanning(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCreateProjectPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>>
    export type ProjectPlanningControllerCreateProjectPlanningMutationBody = CreateProjectPlanningDto
    export type ProjectPlanningControllerCreateProjectPlanningMutationError = void

    /**
 * @summary Create a project (cookie-auth)
 */
export const useProjectPlanningControllerCreateProjectPlanning = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>, TError,{data: CreateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCreateProjectPlanning>>,
        TError,
        {data: CreateProjectPlanningDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerCreateProjectPlanningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns a project with planning metadata and its work orders (with container selections, product keys, and metadata).
 * @summary Get project planning detail
 */
export type projectPlanningControllerGetProjectPlanningResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerGetProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerGetProjectPlanningResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerGetProjectPlanningResponseSuccess = (projectPlanningControllerGetProjectPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerGetProjectPlanningResponseError = (projectPlanningControllerGetProjectPlanningResponse401 | projectPlanningControllerGetProjectPlanningResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerGetProjectPlanningResponse = (projectPlanningControllerGetProjectPlanningResponseSuccess | projectPlanningControllerGetProjectPlanningResponseError)

export const getProjectPlanningControllerGetProjectPlanningUrl = (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/planning?${stringifiedParams}` : `/projects/${projectId}/planning`
}

export const projectPlanningControllerGetProjectPlanning = async (projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: RequestInit): Promise<projectPlanningControllerGetProjectPlanningResponse> => {
  
  return customFetch<projectPlanningControllerGetProjectPlanningResponse>(getProjectPlanningControllerGetProjectPlanningUrl(projectId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerGetProjectPlanningQueryKey = (projectId?: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams,) => {
    return [
    `/projects/${projectId}/planning`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProjectPlanningControllerGetProjectPlanningQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectPlanningQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>> = ({ signal }) => projectPlanningControllerGetProjectPlanning(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerGetProjectPlanningQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>>
export type ProjectPlanningControllerGetProjectPlanningQueryError = void


export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params: undefined |  ProjectPlanningControllerGetProjectPlanningParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get project planning detail
 */

export function useProjectPlanningControllerGetProjectPlanning<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get project planning detail
 */
export const prefetchProjectPlanningControllerGetProjectPlanningQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerGetProjectPlanningSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerGetProjectPlanningQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>> = ({ signal }) => projectPlanningControllerGetProjectPlanning(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerGetProjectPlanningSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>>
export type ProjectPlanningControllerGetProjectPlanningSuspenseQueryError = void


export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params: undefined |  ProjectPlanningControllerGetProjectPlanningParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get project planning detail
 */

export function useProjectPlanningControllerGetProjectPlanningSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError = void>(
 projectId: string,
    params?: ProjectPlanningControllerGetProjectPlanningParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerGetProjectPlanning>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerGetProjectPlanningSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Cookie-auth entry point that updates project metadata (name, code, prefix, dates) via the existing event-sourced ProjectsService. Rejects with 409 unless project_status is "draft" or "redrafting". The hub-side admin PATCH at /projects/:project_id is untouched.
 * @summary Update project metadata (cookie-auth)
 */
export type projectPlanningControllerUpdateProjectPlanningResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerUpdateProjectPlanningResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerUpdateProjectPlanningResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateProjectPlanningResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateProjectPlanningResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerUpdateProjectPlanningResponseSuccess = (projectPlanningControllerUpdateProjectPlanningResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateProjectPlanningResponseError = (projectPlanningControllerUpdateProjectPlanningResponse400 | projectPlanningControllerUpdateProjectPlanningResponse401 | projectPlanningControllerUpdateProjectPlanningResponse404 | projectPlanningControllerUpdateProjectPlanningResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateProjectPlanningResponse = (projectPlanningControllerUpdateProjectPlanningResponseSuccess | projectPlanningControllerUpdateProjectPlanningResponseError)

export const getProjectPlanningControllerUpdateProjectPlanningUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/planning`
}

export const projectPlanningControllerUpdateProjectPlanning = async (projectId: string,
    updateProjectPlanningDto: UpdateProjectPlanningDto, options?: RequestInit): Promise<projectPlanningControllerUpdateProjectPlanningResponse> => {
  
  return customFetch<projectPlanningControllerUpdateProjectPlanningResponse>(getProjectPlanningControllerUpdateProjectPlanningUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProjectPlanningDto,)
  }
);}




export const getProjectPlanningControllerUpdateProjectPlanningMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,{projectId: string;data: UpdateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,{projectId: string;data: UpdateProjectPlanningDto}, TContext> => {

const mutationKey = ['projectPlanningControllerUpdateProjectPlanning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, {projectId: string;data: UpdateProjectPlanningDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateProjectPlanning(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateProjectPlanningMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>>
    export type ProjectPlanningControllerUpdateProjectPlanningMutationBody = UpdateProjectPlanningDto
    export type ProjectPlanningControllerUpdateProjectPlanningMutationError = void

    /**
 * @summary Update project metadata (cookie-auth)
 */
export const useProjectPlanningControllerUpdateProjectPlanning = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>, TError,{projectId: string;data: UpdateProjectPlanningDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectPlanning>>,
        TError,
        {projectId: string;data: UpdateProjectPlanningDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerUpdateProjectPlanningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Persists the AG Grid column state (visibility, order, pinning, width) for the project planning grid. Shared across all users at the partner and reapplied on page load. Allowed on any project status — column layout is presentational and never affects work-order data. Optimistic concurrency: the client passes the project_column_config_updated_at value from its last GET; the server returns 409 if another user has saved in between.
 * @summary Update project planning grid column layout
 */
export type projectPlanningControllerUpdateProjectColumnConfigResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerUpdateProjectColumnConfigResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerUpdateProjectColumnConfigResponseSuccess = (projectPlanningControllerUpdateProjectColumnConfigResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUpdateProjectColumnConfigResponseError = (projectPlanningControllerUpdateProjectColumnConfigResponse401 | projectPlanningControllerUpdateProjectColumnConfigResponse404 | projectPlanningControllerUpdateProjectColumnConfigResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerUpdateProjectColumnConfigResponse = (projectPlanningControllerUpdateProjectColumnConfigResponseSuccess | projectPlanningControllerUpdateProjectColumnConfigResponseError)

export const getProjectPlanningControllerUpdateProjectColumnConfigUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/column-config`
}

export const projectPlanningControllerUpdateProjectColumnConfig = async (projectId: string,
    updateProjectColumnConfigDto: UpdateProjectColumnConfigDto, options?: RequestInit): Promise<projectPlanningControllerUpdateProjectColumnConfigResponse> => {
  
  return customFetch<projectPlanningControllerUpdateProjectColumnConfigResponse>(getProjectPlanningControllerUpdateProjectColumnConfigUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProjectColumnConfigDto,)
  }
);}




export const getProjectPlanningControllerUpdateProjectColumnConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,{projectId: string;data: UpdateProjectColumnConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,{projectId: string;data: UpdateProjectColumnConfigDto}, TContext> => {

const mutationKey = ['projectPlanningControllerUpdateProjectColumnConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, {projectId: string;data: UpdateProjectColumnConfigDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUpdateProjectColumnConfig(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>>
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationBody = UpdateProjectColumnConfigDto
    export type ProjectPlanningControllerUpdateProjectColumnConfigMutationError = void

    /**
 * @summary Update project planning grid column layout
 */
export const useProjectPlanningControllerUpdateProjectColumnConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>, TError,{projectId: string;data: UpdateProjectColumnConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUpdateProjectColumnConfig>>,
        TError,
        {projectId: string;data: UpdateProjectColumnConfigDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerUpdateProjectColumnConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * ENG-822 §12.5: the work orders that would release with no route because their factory's default route cannot build their product type, grouped by product for the Stage 4 release warning. Read-only — it never creates a default route, and a factory with no default yet is reported as assignable because release auto-creates an unscoped default for it. Returns an empty preview when the routing flag is not active for the caller. Release is never blocked by this (§12.2); the affected work orders land in the Missing Routes count and are fixed with Set Route on the Production Plan.
 * @summary Preview which work orders will release without a route
 */
export type projectPlanningControllerPreviewReleaseRoutesResponse200 = {
  data: ReleaseRoutePreviewDto
  status: 200
}

export type projectPlanningControllerPreviewReleaseRoutesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewReleaseRoutesResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerPreviewReleaseRoutesResponseSuccess = (projectPlanningControllerPreviewReleaseRoutesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewReleaseRoutesResponseError = (projectPlanningControllerPreviewReleaseRoutesResponse401 | projectPlanningControllerPreviewReleaseRoutesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewReleaseRoutesResponse = (projectPlanningControllerPreviewReleaseRoutesResponseSuccess | projectPlanningControllerPreviewReleaseRoutesResponseError)

export const getProjectPlanningControllerPreviewReleaseRoutesUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/release-route-preview`
}

export const projectPlanningControllerPreviewReleaseRoutes = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerPreviewReleaseRoutesResponse> => {
  
  return customFetch<projectPlanningControllerPreviewReleaseRoutesResponse>(getProjectPlanningControllerPreviewReleaseRoutesUrl(projectId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerPreviewReleaseRoutesQueryKey = (projectId?: string,) => {
    return [
    `/projects/${projectId}/release-route-preview`
    ] as const;
    }

    
export const getProjectPlanningControllerPreviewReleaseRoutesQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewReleaseRoutesQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>> = ({ signal }) => projectPlanningControllerPreviewReleaseRoutes(projectId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerPreviewReleaseRoutesQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>>
export type ProjectPlanningControllerPreviewReleaseRoutesQueryError = void


export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview which work orders will release without a route
 */

export function useProjectPlanningControllerPreviewReleaseRoutes<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerPreviewReleaseRoutesQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Preview which work orders will release without a route
 */
export const prefetchProjectPlanningControllerPreviewReleaseRoutesQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 queryClient: QueryClient, projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerPreviewReleaseRoutesQueryOptions(projectId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewReleaseRoutesQueryKey(projectId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>> = ({ signal }) => projectPlanningControllerPreviewReleaseRoutes(projectId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>>
export type ProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryError = void


export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview which work orders will release without a route
 */

export function useProjectPlanningControllerPreviewReleaseRoutesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError = void>(
 projectId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewReleaseRoutes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerPreviewReleaseRoutesSuspenseQueryOptions(projectId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Transitions a draft project to released status. Assigns the current Run Sheet version to every draft work order and flips them to "scheduled" status. Sets project_released_by and project_released_at. Rejects with 409 if not in draft status, or 400 if any work order is missing a required container selection.
 * @summary Release a project
 */
export type projectPlanningControllerReleaseProjectResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerReleaseProjectResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerReleaseProjectResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerReleaseProjectResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerReleaseProjectResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerReleaseProjectResponseSuccess = (projectPlanningControllerReleaseProjectResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerReleaseProjectResponseError = (projectPlanningControllerReleaseProjectResponse400 | projectPlanningControllerReleaseProjectResponse401 | projectPlanningControllerReleaseProjectResponse404 | projectPlanningControllerReleaseProjectResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerReleaseProjectResponse = (projectPlanningControllerReleaseProjectResponseSuccess | projectPlanningControllerReleaseProjectResponseError)

export const getProjectPlanningControllerReleaseProjectUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/release`
}

export const projectPlanningControllerReleaseProject = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerReleaseProjectResponse> => {
  
  return customFetch<projectPlanningControllerReleaseProjectResponse>(getProjectPlanningControllerReleaseProjectUrl(projectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getProjectPlanningControllerReleaseProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['projectPlanningControllerReleaseProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerReleaseProject(projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerReleaseProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>>
    
    export type ProjectPlanningControllerReleaseProjectMutationError = void

    /**
 * @summary Release a project
 */
export const useProjectPlanningControllerReleaseProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerReleaseProject>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerReleaseProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Releases the work orders still in "draft" on an already-released or redrafting project — the rows added during a redraft cycle. Assigns the current Run Sheet, renumbers each factory's Manufacturing Sequence, and flips them "draft" → "scheduled". A "redrafting" project returns to "released" once no draft or redrafting rows remain; a row the reconcile leaves in "draft" (no Run Sheet) keeps it open. Used by the re-release flow. Rejects with 409 if the project is still in draft status, or 400 (MISSING_REQUIRED_FIELDS) if any draft work order is missing a required field.
 * @summary Release draft work orders on a redrafting project
 */
export type projectPlanningControllerReleaseDraftWorkOrdersResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerReleaseDraftWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerReleaseDraftWorkOrdersResponseSuccess = (projectPlanningControllerReleaseDraftWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerReleaseDraftWorkOrdersResponseError = (projectPlanningControllerReleaseDraftWorkOrdersResponse400 | projectPlanningControllerReleaseDraftWorkOrdersResponse401 | projectPlanningControllerReleaseDraftWorkOrdersResponse404 | projectPlanningControllerReleaseDraftWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerReleaseDraftWorkOrdersResponse = (projectPlanningControllerReleaseDraftWorkOrdersResponseSuccess | projectPlanningControllerReleaseDraftWorkOrdersResponseError)

export const getProjectPlanningControllerReleaseDraftWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/release-drafts`
}

export const projectPlanningControllerReleaseDraftWorkOrders = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerReleaseDraftWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerReleaseDraftWorkOrdersResponse>(getProjectPlanningControllerReleaseDraftWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getProjectPlanningControllerReleaseDraftWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['projectPlanningControllerReleaseDraftWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerReleaseDraftWorkOrders(projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>>
    
    export type ProjectPlanningControllerReleaseDraftWorkOrdersMutationError = void

    /**
 * @summary Release draft work orders on a redrafting project
 */
export const useProjectPlanningControllerReleaseDraftWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerReleaseDraftWorkOrders>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerReleaseDraftWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Moves a released project back to draft. Only work orders still in "scheduled" status revert to "draft"; work orders already "in_progress" or "complete" are left untouched. Returns 409 if the project is not in released status.
 * @summary Move a released project back to draft
 */
export type projectPlanningControllerMoveProjectToDraftResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerMoveProjectToDraftResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerMoveProjectToDraftResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerMoveProjectToDraftResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerMoveProjectToDraftResponseSuccess = (projectPlanningControllerMoveProjectToDraftResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerMoveProjectToDraftResponseError = (projectPlanningControllerMoveProjectToDraftResponse401 | projectPlanningControllerMoveProjectToDraftResponse404 | projectPlanningControllerMoveProjectToDraftResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerMoveProjectToDraftResponse = (projectPlanningControllerMoveProjectToDraftResponseSuccess | projectPlanningControllerMoveProjectToDraftResponseError)

export const getProjectPlanningControllerMoveProjectToDraftUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/move-to-draft`
}

export const projectPlanningControllerMoveProjectToDraft = async (projectId: string, options?: RequestInit): Promise<projectPlanningControllerMoveProjectToDraftResponse> => {
  
  return customFetch<projectPlanningControllerMoveProjectToDraftResponse>(getProjectPlanningControllerMoveProjectToDraftUrl(projectId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getProjectPlanningControllerMoveProjectToDraftMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,{projectId: string}, TContext> => {

const mutationKey = ['projectPlanningControllerMoveProjectToDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, {projectId: string}> = (props) => {
          const {projectId} = props ?? {};

          return  projectPlanningControllerMoveProjectToDraft(projectId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerMoveProjectToDraftMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>>
    
    export type ProjectPlanningControllerMoveProjectToDraftMutationError = void

    /**
 * @summary Move a released project back to draft
 */
export const useProjectPlanningControllerMoveProjectToDraft = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>, TError,{projectId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerMoveProjectToDraft>>,
        TError,
        {projectId: string},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerMoveProjectToDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reopens a released project for edits by setting project_status to "redrafting" — unconditionally, even when the project has nothing eligible to reopen (an empty project, or one where every work order is archived, in_progress, or complete). This is what lets new work orders be added to a released project again, manually or via import. Optionally reopens a subset of the project's own eligible `scheduled` rows to `redrafting` in the same call: omit work_order_ids to reopen every eligible row, or pass an explicit empty array to flip project_status only and reopen none. Any requested id that is not one of the project's own eligible scheduled rows is silently ignored. Calling this on an already-redrafting project is allowed (the status write is a no-op) and can still reopen additional rows. Rejects with 409 if the project is still draft — nothing has ever been released to reopen.
 * @summary Redraft a released project (ENG-830)
 */
export type projectPlanningControllerRedraftProjectResponse200 = {
  data: ProjectPlanningDetailDto
  status: 200
}

export type projectPlanningControllerRedraftProjectResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerRedraftProjectResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerRedraftProjectResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerRedraftProjectResponseSuccess = (projectPlanningControllerRedraftProjectResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerRedraftProjectResponseError = (projectPlanningControllerRedraftProjectResponse401 | projectPlanningControllerRedraftProjectResponse404 | projectPlanningControllerRedraftProjectResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerRedraftProjectResponse = (projectPlanningControllerRedraftProjectResponseSuccess | projectPlanningControllerRedraftProjectResponseError)

export const getProjectPlanningControllerRedraftProjectUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/redraft`
}

export const projectPlanningControllerRedraftProject = async (projectId: string,
    redraftProjectDto: RedraftProjectDto, options?: RequestInit): Promise<projectPlanningControllerRedraftProjectResponse> => {
  
  return customFetch<projectPlanningControllerRedraftProjectResponse>(getProjectPlanningControllerRedraftProjectUrl(projectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      redraftProjectDto,)
  }
);}




export const getProjectPlanningControllerRedraftProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, TError,{projectId: string;data: RedraftProjectDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, TError,{projectId: string;data: RedraftProjectDto}, TContext> => {

const mutationKey = ['projectPlanningControllerRedraftProject'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, {projectId: string;data: RedraftProjectDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerRedraftProject(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerRedraftProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>>
    export type ProjectPlanningControllerRedraftProjectMutationBody = RedraftProjectDto
    export type ProjectPlanningControllerRedraftProjectMutationError = void

    /**
 * @summary Redraft a released project (ENG-830)
 */
export const useProjectPlanningControllerRedraftProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>, TError,{projectId: string;data: RedraftProjectDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerRedraftProject>>,
        TError,
        {projectId: string;data: RedraftProjectDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerRedraftProjectMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Computes the Spread Dates readout without writing anything: the start window (First/Last Start with lead time and buffer walked back in work days over the factory's shift calendar), weeks W, the draft/redrafting work order count N, the dated/fully-dated counts driving the overwrite confirmation and the Keep lead-time option, required throughput per week (N ÷ W), a week-grid summary of the shift pattern, and the area demand summary (sum of the area Standard Column over rows matching the partner's default unit; null when no row matches). Under Keep, limiting_lead_time identifies the first-in-sequence work order whose current or fallback lead limits Last Start, including for a closed window; it is null under Set. The window runs from the Spread Start Date (default: project start) to project complete. Powers the modal's live readout — re-fetched on every input change.
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */
export type projectPlanningControllerPreviewDraftDatesResponse200 = {
  data: DraftDatesPreviewDto
  status: 200
}

export type projectPlanningControllerPreviewDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerPreviewDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewDraftDatesResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerPreviewDraftDatesResponseSuccess = (projectPlanningControllerPreviewDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewDraftDatesResponseError = (projectPlanningControllerPreviewDraftDatesResponse400 | projectPlanningControllerPreviewDraftDatesResponse401 | projectPlanningControllerPreviewDraftDatesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewDraftDatesResponse = (projectPlanningControllerPreviewDraftDatesResponseSuccess | projectPlanningControllerPreviewDraftDatesResponseError)

export const getProjectPlanningControllerPreviewDraftDatesUrl = (projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/draft-dates/preview?${stringifiedParams}` : `/projects/${projectId}/draft-dates/preview`
}

export const projectPlanningControllerPreviewDraftDates = async (projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: RequestInit): Promise<projectPlanningControllerPreviewDraftDatesResponse> => {
  
  return customFetch<projectPlanningControllerPreviewDraftDatesResponse>(getProjectPlanningControllerPreviewDraftDatesUrl(projectId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerPreviewDraftDatesQueryKey = (projectId?: string,
    params?: ProjectPlanningControllerPreviewDraftDatesParams,) => {
    return [
    `/projects/${projectId}/draft-dates/preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProjectPlanningControllerPreviewDraftDatesQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewDraftDatesQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewDraftDates(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerPreviewDraftDatesQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>>
export type ProjectPlanningControllerPreviewDraftDatesQueryError = void


export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */

export function useProjectPlanningControllerPreviewDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerPreviewDraftDatesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */
export const prefetchProjectPlanningControllerPreviewDraftDatesQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerPreviewDraftDatesQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerPreviewDraftDatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewDraftDatesQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewDraftDates(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerPreviewDraftDatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>>
export type ProjectPlanningControllerPreviewDraftDatesSuspenseQueryError = void


export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview Spread Dates for a project (ENG-705/ENG-819)
 */

export function useProjectPlanningControllerPreviewDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerPreviewDraftDatesSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Spreads Scheduled Start / Scheduled Complete timestamps evenly across the net working hours of the factory's shift calendar between the Spread Start Date (default: project start) and the project complete date, over the factory's draft/redrafting work orders in project-sequence order — started work is never touched. Under lead_time_mode 'keep', each work order holding both dates keeps its own lead time and the walk-back uses the longest lead in the draft. Everything is recomputed server-side at click time. Both timestamps are written in ONE transaction (all-or-nothing); the shift-refs trigger derives the slot references automatically. Only draft or redrafting projects can be drafted (409 otherwise). Work orders on other factories, or with no factory, are untouched.
 * @summary Spread Dates: write scheduled start/complete onto work orders (ENG-705/ENG-819)
 */
export type projectPlanningControllerCommitDraftDatesResponse200 = {
  data: CommitDraftDatesResultDto
  status: 200
}

export type projectPlanningControllerCommitDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerCommitDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCommitDraftDatesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerCommitDraftDatesResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerCommitDraftDatesResponseSuccess = (projectPlanningControllerCommitDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerCommitDraftDatesResponseError = (projectPlanningControllerCommitDraftDatesResponse400 | projectPlanningControllerCommitDraftDatesResponse401 | projectPlanningControllerCommitDraftDatesResponse404 | projectPlanningControllerCommitDraftDatesResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerCommitDraftDatesResponse = (projectPlanningControllerCommitDraftDatesResponseSuccess | projectPlanningControllerCommitDraftDatesResponseError)

export const getProjectPlanningControllerCommitDraftDatesUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/draft-dates`
}

export const projectPlanningControllerCommitDraftDates = async (projectId: string,
    commitDraftDatesDto: CommitDraftDatesDto, options?: RequestInit): Promise<projectPlanningControllerCommitDraftDatesResponse> => {
  
  return customFetch<projectPlanningControllerCommitDraftDatesResponse>(getProjectPlanningControllerCommitDraftDatesUrl(projectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commitDraftDatesDto,)
  }
);}




export const getProjectPlanningControllerCommitDraftDatesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, TError,{projectId: string;data: CommitDraftDatesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, TError,{projectId: string;data: CommitDraftDatesDto}, TContext> => {

const mutationKey = ['projectPlanningControllerCommitDraftDates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, {projectId: string;data: CommitDraftDatesDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerCommitDraftDates(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCommitDraftDatesMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>>
    export type ProjectPlanningControllerCommitDraftDatesMutationBody = CommitDraftDatesDto
    export type ProjectPlanningControllerCommitDraftDatesMutationError = void

    /**
 * @summary Spread Dates: write scheduled start/complete onto work orders (ENG-705/ENG-819)
 */
export const useProjectPlanningControllerCommitDraftDates = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>, TError,{projectId: string;data: CommitDraftDatesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCommitDraftDates>>,
        TError,
        {projectId: string;data: CommitDraftDatesDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerCommitDraftDatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Computes the Pull Dates readout without writing anything. Each draft/redrafting work order works back from its own value in the chosen driving date column — buffer work days back to a scheduled complete, lead time back to a scheduled start, on the factory's shift calendar. Work orders with no driving value are listed as skipped and will be left untouched. The demand readout window is clamped to today on the factory's clock (window start = max(project start, today), end = max(project complete, today)); when project complete is on or before today, the window is closed and the demand numbers are null — drafting itself is never blocked by the window.
 * @summary Preview Pull Dates for a project (ENG-819)
 */
export type projectPlanningControllerPreviewPullDraftDatesResponse200 = {
  data: PullDraftDatesPreviewDto
  status: 200
}

export type projectPlanningControllerPreviewPullDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerPreviewPullDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerPreviewPullDraftDatesResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerPreviewPullDraftDatesResponseSuccess = (projectPlanningControllerPreviewPullDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerPreviewPullDraftDatesResponseError = (projectPlanningControllerPreviewPullDraftDatesResponse400 | projectPlanningControllerPreviewPullDraftDatesResponse401 | projectPlanningControllerPreviewPullDraftDatesResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerPreviewPullDraftDatesResponse = (projectPlanningControllerPreviewPullDraftDatesResponseSuccess | projectPlanningControllerPreviewPullDraftDatesResponseError)

export const getProjectPlanningControllerPreviewPullDraftDatesUrl = (projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects/${projectId}/draft-dates/pull/preview?${stringifiedParams}` : `/projects/${projectId}/draft-dates/pull/preview`
}

export const projectPlanningControllerPreviewPullDraftDates = async (projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: RequestInit): Promise<projectPlanningControllerPreviewPullDraftDatesResponse> => {
  
  return customFetch<projectPlanningControllerPreviewPullDraftDatesResponse>(getProjectPlanningControllerPreviewPullDraftDatesUrl(projectId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getProjectPlanningControllerPreviewPullDraftDatesQueryKey = (projectId?: string,
    params?: ProjectPlanningControllerPreviewPullDraftDatesParams,) => {
    return [
    `/projects/${projectId}/draft-dates/pull/preview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getProjectPlanningControllerPreviewPullDraftDatesQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewPullDraftDatesQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewPullDraftDates(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(projectId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerPreviewPullDraftDatesQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>>
export type ProjectPlanningControllerPreviewPullDraftDatesQueryError = void


export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>,
          TError,
          Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview Pull Dates for a project (ENG-819)
 */

export function useProjectPlanningControllerPreviewPullDraftDates<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerPreviewPullDraftDatesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Preview Pull Dates for a project (ENG-819)
 */
export const prefetchProjectPlanningControllerPreviewPullDraftDatesQuery = async <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 queryClient: QueryClient, projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectPlanningControllerPreviewPullDraftDatesQueryOptions(projectId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectPlanningControllerPreviewPullDraftDatesQueryKey(projectId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>> = ({ signal }) => projectPlanningControllerPreviewPullDraftDates(projectId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>>
export type ProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryError = void


export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Preview Pull Dates for a project (ENG-819)
 */

export function useProjectPlanningControllerPreviewPullDraftDatesSuspense<TData = Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError = void>(
 projectId: string,
    params: ProjectPlanningControllerPreviewPullDraftDatesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectPlanningControllerPreviewPullDraftDates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getProjectPlanningControllerPreviewPullDraftDatesSuspenseQueryOptions(projectId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * For each draft/redrafting work order with a value in the driving date column: scheduled complete = that value walked back by the buffer in work days, scheduled start = the complete walked back by the production lead time ('set' flat value, or each work order's own kept lead under 'keep'), both on the factory's shift calendar. Work orders missing the driving value are skipped and untouched — skips are recomputed server-side at click time. All written rows commit in ONE transaction (all-or-nothing); a draft where every work order is skipped writes nothing and succeeds with updated_count 0. Only draft or redrafting projects can be drafted (409 otherwise).
 * @summary Pull Dates: write scheduled start/complete walked back from a driving column (ENG-819)
 */
export type projectPlanningControllerCommitPullDraftDatesResponse200 = {
  data: CommitPullDraftDatesResultDto
  status: 200
}

export type projectPlanningControllerCommitPullDraftDatesResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerCommitPullDraftDatesResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerCommitPullDraftDatesResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerCommitPullDraftDatesResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerCommitPullDraftDatesResponseSuccess = (projectPlanningControllerCommitPullDraftDatesResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerCommitPullDraftDatesResponseError = (projectPlanningControllerCommitPullDraftDatesResponse400 | projectPlanningControllerCommitPullDraftDatesResponse401 | projectPlanningControllerCommitPullDraftDatesResponse404 | projectPlanningControllerCommitPullDraftDatesResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerCommitPullDraftDatesResponse = (projectPlanningControllerCommitPullDraftDatesResponseSuccess | projectPlanningControllerCommitPullDraftDatesResponseError)

export const getProjectPlanningControllerCommitPullDraftDatesUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/draft-dates/pull`
}

export const projectPlanningControllerCommitPullDraftDates = async (projectId: string,
    commitPullDraftDatesDto: CommitPullDraftDatesDto, options?: RequestInit): Promise<projectPlanningControllerCommitPullDraftDatesResponse> => {
  
  return customFetch<projectPlanningControllerCommitPullDraftDatesResponse>(getProjectPlanningControllerCommitPullDraftDatesUrl(projectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      commitPullDraftDatesDto,)
  }
);}




export const getProjectPlanningControllerCommitPullDraftDatesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, TError,{projectId: string;data: CommitPullDraftDatesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, TError,{projectId: string;data: CommitPullDraftDatesDto}, TContext> => {

const mutationKey = ['projectPlanningControllerCommitPullDraftDates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, {projectId: string;data: CommitPullDraftDatesDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerCommitPullDraftDates(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerCommitPullDraftDatesMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>>
    export type ProjectPlanningControllerCommitPullDraftDatesMutationBody = CommitPullDraftDatesDto
    export type ProjectPlanningControllerCommitPullDraftDatesMutationError = void

    /**
 * @summary Pull Dates: write scheduled start/complete walked back from a driving column (ENG-819)
 */
export const useProjectPlanningControllerCommitPullDraftDates = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>, TError,{projectId: string;data: CommitPullDraftDatesDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerCommitPullDraftDates>>,
        TError,
        {projectId: string;data: CommitPullDraftDatesDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerCommitPullDraftDatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Creates the specified number of work order rows on a draft project, each sharing a Product seeded with the supplied Product Type. When the partner has exactly one factory, it is pre-selected on every new work order. Returns all work orders on the project.
 * @summary Batch add work orders to a project
 */
export type projectPlanningControllerBatchAddWorkOrdersResponse201 = {
  data: ProjectWorkOrderDetailDto[]
  status: 201
}

export type projectPlanningControllerBatchAddWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerBatchAddWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchAddWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchAddWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerBatchAddWorkOrdersResponseSuccess = (projectPlanningControllerBatchAddWorkOrdersResponse201) & {
  headers: Headers;
};
export type projectPlanningControllerBatchAddWorkOrdersResponseError = (projectPlanningControllerBatchAddWorkOrdersResponse400 | projectPlanningControllerBatchAddWorkOrdersResponse401 | projectPlanningControllerBatchAddWorkOrdersResponse404 | projectPlanningControllerBatchAddWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchAddWorkOrdersResponse = (projectPlanningControllerBatchAddWorkOrdersResponseSuccess | projectPlanningControllerBatchAddWorkOrdersResponseError)

export const getProjectPlanningControllerBatchAddWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders`
}

export const projectPlanningControllerBatchAddWorkOrders = async (projectId: string,
    batchAddWorkOrdersDto: BatchAddWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerBatchAddWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerBatchAddWorkOrdersResponse>(getProjectPlanningControllerBatchAddWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchAddWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerBatchAddWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,{projectId: string;data: BatchAddWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,{projectId: string;data: BatchAddWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerBatchAddWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, {projectId: string;data: BatchAddWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchAddWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchAddWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>>
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationBody = BatchAddWorkOrdersDto
    export type ProjectPlanningControllerBatchAddWorkOrdersMutationError = void

    /**
 * @summary Batch add work orders to a project
 */
export const useProjectPlanningControllerBatchAddWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>, TError,{projectId: string;data: BatchAddWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchAddWorkOrders>>,
        TError,
        {projectId: string;data: BatchAddWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerBatchAddWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Deletes the specified work orders and their associated products from a draft project. Returns remaining work orders.
 * @summary Batch remove work orders from a project
 */
export type projectPlanningControllerBatchRemoveWorkOrdersResponse200 = {
  data: ProjectWorkOrderDetailDto[]
  status: 200
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchRemoveWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerBatchRemoveWorkOrdersResponseSuccess = (projectPlanningControllerBatchRemoveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerBatchRemoveWorkOrdersResponseError = (projectPlanningControllerBatchRemoveWorkOrdersResponse401 | projectPlanningControllerBatchRemoveWorkOrdersResponse404 | projectPlanningControllerBatchRemoveWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchRemoveWorkOrdersResponse = (projectPlanningControllerBatchRemoveWorkOrdersResponseSuccess | projectPlanningControllerBatchRemoveWorkOrdersResponseError)

export const getProjectPlanningControllerBatchRemoveWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders`
}

export const projectPlanningControllerBatchRemoveWorkOrders = async (projectId: string,
    batchRemoveWorkOrdersDto: BatchRemoveWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerBatchRemoveWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerBatchRemoveWorkOrdersResponse>(getProjectPlanningControllerBatchRemoveWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchRemoveWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerBatchRemoveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,{projectId: string;data: BatchRemoveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,{projectId: string;data: BatchRemoveWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerBatchRemoveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, {projectId: string;data: BatchRemoveWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchRemoveWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>>
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationBody = BatchRemoveWorkOrdersDto
    export type ProjectPlanningControllerBatchRemoveWorkOrdersMutationError = void

    /**
 * @summary Batch remove work orders from a project
 */
export const useProjectPlanningControllerBatchRemoveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>, TError,{projectId: string;data: BatchRemoveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchRemoveWorkOrders>>,
        TError,
        {projectId: string;data: BatchRemoveWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerBatchRemoveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Applies an array of cell-level updates to work orders on a draft project. Each update targets a work order field (scalar) or a container selection (UUID field). Recalculates Product Codes after container changes.
 * @summary Batch update work order cells
 */
export type projectPlanningControllerBatchUpdateWorkOrdersResponse200 = {
  data: ProjectWorkOrderDetailDto[]
  status: 200
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse400 = {
  data: void
  status: 400
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse404 = {
  data: void
  status: 404
}

export type projectPlanningControllerBatchUpdateWorkOrdersResponse409 = {
  data: void
  status: 409
}
    
export type projectPlanningControllerBatchUpdateWorkOrdersResponseSuccess = (projectPlanningControllerBatchUpdateWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerBatchUpdateWorkOrdersResponseError = (projectPlanningControllerBatchUpdateWorkOrdersResponse400 | projectPlanningControllerBatchUpdateWorkOrdersResponse401 | projectPlanningControllerBatchUpdateWorkOrdersResponse404 | projectPlanningControllerBatchUpdateWorkOrdersResponse409) & {
  headers: Headers;
};

export type projectPlanningControllerBatchUpdateWorkOrdersResponse = (projectPlanningControllerBatchUpdateWorkOrdersResponseSuccess | projectPlanningControllerBatchUpdateWorkOrdersResponseError)

export const getProjectPlanningControllerBatchUpdateWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders/batch`
}

export const projectPlanningControllerBatchUpdateWorkOrders = async (projectId: string,
    batchUpdateWorkOrdersDto: BatchUpdateWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerBatchUpdateWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerBatchUpdateWorkOrdersResponse>(getProjectPlanningControllerBatchUpdateWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      batchUpdateWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerBatchUpdateWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,{projectId: string;data: BatchUpdateWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,{projectId: string;data: BatchUpdateWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerBatchUpdateWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, {projectId: string;data: BatchUpdateWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerBatchUpdateWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>>
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationBody = BatchUpdateWorkOrdersDto
    export type ProjectPlanningControllerBatchUpdateWorkOrdersMutationError = void

    /**
 * @summary Batch update work order cells
 */
export const useProjectPlanningControllerBatchUpdateWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>, TError,{projectId: string;data: BatchUpdateWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerBatchUpdateWorkOrders>>,
        TError,
        {projectId: string;data: BatchUpdateWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerBatchUpdateWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Archives the submitted work orders that are in `scheduled` or `redrafting` status, removing them from active planning views without deleting any data. Work orders in any other status (in_progress, complete, draft, already archived) are left untouched and returned in `skipped`. Each archive is recorded in the audit trail.
 * @summary Archive work orders on a project
 */
export type projectPlanningControllerArchiveWorkOrdersResponse200 = {
  data: ArchiveWorkOrdersResultDto
  status: 200
}

export type projectPlanningControllerArchiveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerArchiveWorkOrdersResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerArchiveWorkOrdersResponseSuccess = (projectPlanningControllerArchiveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerArchiveWorkOrdersResponseError = (projectPlanningControllerArchiveWorkOrdersResponse401 | projectPlanningControllerArchiveWorkOrdersResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerArchiveWorkOrdersResponse = (projectPlanningControllerArchiveWorkOrdersResponseSuccess | projectPlanningControllerArchiveWorkOrdersResponseError)

export const getProjectPlanningControllerArchiveWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders/archive`
}

export const projectPlanningControllerArchiveWorkOrders = async (projectId: string,
    archiveWorkOrdersDto: ArchiveWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerArchiveWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerArchiveWorkOrdersResponse>(getProjectPlanningControllerArchiveWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      archiveWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerArchiveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,{projectId: string;data: ArchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,{projectId: string;data: ArchiveWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerArchiveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, {projectId: string;data: ArchiveWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerArchiveWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerArchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>>
    export type ProjectPlanningControllerArchiveWorkOrdersMutationBody = ArchiveWorkOrdersDto
    export type ProjectPlanningControllerArchiveWorkOrdersMutationError = void

    /**
 * @summary Archive work orders on a project
 */
export const useProjectPlanningControllerArchiveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>, TError,{projectId: string;data: ArchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerArchiveWorkOrders>>,
        TError,
        {projectId: string;data: ArchiveWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerArchiveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Restores the submitted archived work orders to the active view, recomputing their lifecycle status from start/complete dates and Run Sheet assignment. Work orders that are not currently archived are returned in `skipped`. Each unarchive is recorded in the audit trail.
 * @summary Unarchive work orders on a project
 */
export type projectPlanningControllerUnarchiveWorkOrdersResponse200 = {
  data: UnarchiveWorkOrdersResultDto
  status: 200
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse401 = {
  data: void
  status: 401
}

export type projectPlanningControllerUnarchiveWorkOrdersResponse404 = {
  data: void
  status: 404
}
    
export type projectPlanningControllerUnarchiveWorkOrdersResponseSuccess = (projectPlanningControllerUnarchiveWorkOrdersResponse200) & {
  headers: Headers;
};
export type projectPlanningControllerUnarchiveWorkOrdersResponseError = (projectPlanningControllerUnarchiveWorkOrdersResponse401 | projectPlanningControllerUnarchiveWorkOrdersResponse404) & {
  headers: Headers;
};

export type projectPlanningControllerUnarchiveWorkOrdersResponse = (projectPlanningControllerUnarchiveWorkOrdersResponseSuccess | projectPlanningControllerUnarchiveWorkOrdersResponseError)

export const getProjectPlanningControllerUnarchiveWorkOrdersUrl = (projectId: string,) => {


  

  return `/projects/${projectId}/work-orders/unarchive`
}

export const projectPlanningControllerUnarchiveWorkOrders = async (projectId: string,
    unarchiveWorkOrdersDto: UnarchiveWorkOrdersDto, options?: RequestInit): Promise<projectPlanningControllerUnarchiveWorkOrdersResponse> => {
  
  return customFetch<projectPlanningControllerUnarchiveWorkOrdersResponse>(getProjectPlanningControllerUnarchiveWorkOrdersUrl(projectId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      unarchiveWorkOrdersDto,)
  }
);}




export const getProjectPlanningControllerUnarchiveWorkOrdersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,{projectId: string;data: UnarchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,{projectId: string;data: UnarchiveWorkOrdersDto}, TContext> => {

const mutationKey = ['projectPlanningControllerUnarchiveWorkOrders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, {projectId: string;data: UnarchiveWorkOrdersDto}> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectPlanningControllerUnarchiveWorkOrders(projectId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationResult = NonNullable<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>>
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationBody = UnarchiveWorkOrdersDto
    export type ProjectPlanningControllerUnarchiveWorkOrdersMutationError = void

    /**
 * @summary Unarchive work orders on a project
 */
export const useProjectPlanningControllerUnarchiveWorkOrders = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>, TError,{projectId: string;data: UnarchiveWorkOrdersDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectPlanningControllerUnarchiveWorkOrders>>,
        TError,
        {projectId: string;data: UnarchiveWorkOrdersDto},
        TContext
      > => {

      const mutationOptions = getProjectPlanningControllerUnarchiveWorkOrdersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    